import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { PlayStyleSelectionActionDetail } from './components/PlayStyleSelectionActionDetail';
import { getTreeParent } from '../../../../shared/action/ActionTreeModel';
export const SetPlayStyleActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  const parentTree = getTreeParent(action);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlayStyleSelectionActionDetail, {
    name: t("action_editor.property_play_style"),
    value: action.playStyle,
    valueSetter: action.setPlayStyle.bind(action),
    parentTree: parentTree
  }));
});